import React from "react";
import RequestsWaitingContent from "../../Component/RequestsWaiting/RequestsWaitingContent";


function RequestsWaiting() {
  return   <RequestsWaitingContent />
      
}

export default RequestsWaiting;
